<h1 class="colorSearch" mat-dialog-title>SELEZIONE DPGR PER LA RICHIESTA</h1>
<div mat-dialog-header>
    <div class="flex-row-left" [formGroup]="form">
        <mat-form-field appearance="fill" color='accent' class="searchbar">
            <mat-label class="purp">Filtra...</mat-label>
            <input matInput [formControlName]="'filtro'">
        </mat-form-field>
        <button mat-stroked-button color='basic' class="pers2 mleft" (click)="onReset()">
            RESET
        </button>
        <button mat-flat-button color='accent' class="pers3 mleft" (click)="ricercaListaEventi(true)">
            FILTRA
        </button>
    </div>
</div>
<div mat-dialog-content>
    <mat-table [dataSource]="dataSource" matSort matSortActive="dataEvento" matSortDirection="desc" matSortDisableClear>

        <ng-container matColumnDef="dpgr">
            <mat-header-cell *matHeaderCellDef mat-sort-header> DPGR </mat-header-cell>
            <mat-cell [attr.data-label]="'DPGR'" *matCellDef="let element">
                {{element.dpgr}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="denominazione">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Denominazione </mat-header-cell>
            <mat-cell [matTooltip]="element.descrizione" [matTooltipPosition]="'left'"
                [matTooltipClass]="'pers-tooltip'" [attr.data-label]="'DENOMINAZIONE'" *matCellDef="let element">
                {{element.denominazione}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dataEvento">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Data DPGR </mat-header-cell>
            <mat-cell [attr.data-label]="'DATA DPGR:'" *matCellDef="let element">
                {{element.dataEvento | date: 'dd/MM/yyyy'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="aggiungi">
            <mat-header-cell *matHeaderCellDef>
                <mat-checkbox class="example-margin" [checked]="aggiungiTutti==='S'?true : false" (change)="setAll($event.checked)"> Aggiungi </mat-checkbox>
            </mat-header-cell>
            <mat-cell [attr.data-label]="'aggiungi'" *matCellDef="let element">
                <mat-checkbox
                class="example-margin"
                (change)="sendDpgr(element)"
                [checked]="element.aggiunto===true?true:false">
                </mat-checkbox>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <div *ngIf="this.dataSource.counter$.source['value'] === 0">
        <mat-card class="emptyTable">
            <mat-card-content>
                <h6>Non ci sono risultati</h6>
            </mat-card-content>
        </mat-card>
    </div>

    <mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina"
        [pageSizeOptions]="[3, 5, 10]"></mat-paginator>

</div>
<mat-dialog-actions align="end">
    <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
        <p class='cont'>ANNULLA</p>
    </button>
    <button mat-raised-button color='accent' class='persBtn' (click)="openAggiungiDpgrDialogConfirm()" [disabled]="this.dataSource.counter$.source['value'] === 0">
        <p class='cont'>ESEGUI</p>
    </button>
</mat-dialog-actions>
